import React, { useState, useEffect, useMemo, useRef } from 'react';
import Select from './store/ThemedSelect';
import { Modal, Form, Table, Button, Dropdown, Pagination, Row, Col, Card, Badge } from 'react-bootstrap';
import { useAuth } from './store/AuthContext';
import { useUserData } from './store/UserDataContext';
import { useNavigate } from 'react-router-dom';
import { backendURL } from './IPaddress';
import './CSS/CRUDfiles.css';
import NavbarComponent from './Nav';
import 'bootstrap-icons/font/bootstrap-icons.css';
import ErrorModalMessage from './store/ErrorMessage';
import { useSchoolYear } from './store/SchoolYearCalculator';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import EmailModal from './store/EmailModal';
import useWebSocketRoom from './store/useWebSocketRoom';
import { buildStaffTicketingRoom } from './store/websocketRooms';

const INITIAL_FORM_DATA = {
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    student_name: '',
    teacher_status: false,
    cactus_number: '',
    school_id: '',
    district: '',
    event_program_id: '',
    event_date_id: '',
    grade_id: '',
    additional_contact: false,
    street: '',
    city: '',
    state: '',
    zip: '',
    names_to_sit_by: '',
    cactus_number_verified: null
};

const INITIAL_TICKET_FORM = {
    app_user_id: '',
    event_date_id: '',
    notes: '',
    order_number: '',
    seat_number: '',
    status_type: '',
    ticket_id: '',
    ticket_mailed: false,
    ticket_pulled: false
};

const SEARCH_TERM_OPTIONS = [
    "Name",
    "Ticket Info",
    "School (District) Info",
    "Contact Info",
    "Record Status",
    "Submitted Date",
    "Ticket Status",
    "Teachers",
    "Cactus Unverified"
];

const formatTime12Hour = (timeString) => {
    if (!timeString || typeof timeString !== 'string') return '';
    const timeParts = timeString.split(':');
    if (timeParts.length < 2) return timeString;
    const date = new Date();
    date.setHours(parseInt(timeParts[0], 10), parseInt(timeParts[1], 10), parseInt(timeParts[2] || '0', 10));
    return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
};

const getContrastTextColor = (backgroundColor) => {
    if (!backgroundColor) return '#111827';

    const namedColors = {
        white: [255, 255, 255],
        black: [0, 0, 0],
        red: [255, 0, 0],
        green: [0, 128, 0],
        blue: [0, 0, 255],
        yellow: [255, 255, 0],
        orange: [255, 165, 0],
        gray: [128, 128, 128],
        grey: [128, 128, 128],
        maroon: [128, 0, 0],
        navy: [0, 0, 128],
        purple: [128, 0, 128]
    };

    const normalized = String(backgroundColor).trim().toLowerCase();
    let r; let g; let b;

    if (normalized.startsWith('#')) {
        const hex = normalized.slice(1);
        if (hex.length === 3) {
            r = parseInt(hex[0] + hex[0], 16);
            g = parseInt(hex[1] + hex[1], 16);
            b = parseInt(hex[2] + hex[2], 16);
        } else if (hex.length === 6) {
            r = parseInt(hex.slice(0, 2), 16);
            g = parseInt(hex.slice(2, 4), 16);
            b = parseInt(hex.slice(4, 6), 16);
        }
    } else if (normalized.startsWith('rgb')) {
        const match = normalized.match(/\d+/g);
        if (match && match.length >= 3) {
            r = Number(match[0]);
            g = Number(match[1]);
            b = Number(match[2]);
        }
    } else if (namedColors[normalized]) {
        [r, g, b] = namedColors[normalized];
    }

    if ([r, g, b].some((v) => Number.isNaN(v) || v === undefined)) return '#111827';

    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return yiq >= 145 ? '#111827' : '#f8fafc';
};

const EventTemplateComponent = () => {
    const [formData, setFormData] = useState(INITIAL_FORM_DATA);
    const [showForm, setShowForm] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [submissionToDelete, setSubmissionToDelete] = useState(null);
    const { authState } = useAuth();
    const { userData } = useUserData();
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');
    const [grades, setGrades] = useState([]);
    const [schools, setSchools] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [eventPrograms, setEventPrograms] = useState([]);
    const [eventDates, setEventDates] = useState([]);
    const [ ticketStatus, setTicketStatus ] = useState([])
    const [loading, setLoading] = useState({
        grades: false,
        schools: false,
        eventPrograms: false,
        eventDates: false
    });
    const [error, setError] = useState({
        grades: null,
        schools: null,
        eventPrograms: null,
        eventDates: null
    }); 
    const [selectedEventProgram, setSelectedEventProgram] = useState(null);
    const [selectedSchool, setSelectedSchool] = useState(null);
    const [privateSchoolModal, setPrivateSchoolModal] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [homeSchoolModal, setHomeSchoolModal] = useState(false);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [ineligibleGradeModal, setIneligibleGradeModal] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [ recordStatuses, setRecordStatuses ] = useState([]);
    const [lastModifiedBy, setLastModifiedBy] = useState('');
    const [usersNames, setUsersNames] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [ showTicketInfoMod, setShowTicketInfoMod ] = useState(false);
    const [ showTicketsNotesMod, setShowTicketNotesMod ] = useState(false);
    const [ showTicketEmailMod, setShowTicketEmailMod ] = useState(false);
    const [ ticketToEdit, setTicketToEdit ] = useState(null);
    const [ ticketForm, setTicketForm ] = useState(INITIAL_TICKET_FORM)
    const [ submissionLastModified, setSubmissionLastModified ] =useState(null);
    const [ showInsufficientPrivileges, setShowInsufficientPrivileges ] = useState(false);
    const scrollableTableRef = useRef(null);
    const currentScrollPosition = scrollableTableRef.current?.scrollTop;
    const [selectedSearchTerm, setSelectedSearchTerm] = useState('Name');
    const [USAstates, setUSAstates] = useState([]);
    const [errorMessage, setErrorMessage ] = useState(null);
    const [schoolYearList, setSchoolYearList] = useState([]);
    const {currentYear, schoolYearListParent} = useSchoolYear();
    const [selectedSchoolYear, setSelectedSchoolYear] = useState(currentYear);
    const recordsPerPage = 100;
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [allFormSubmissions, setAllFormSubmissions] = useState([]);
    const [displayedFormSubmissions, setDisplayedFormSubmissions] = useState([]);
    const [filteredSubmissions, setFilteredSubmissions] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [showEmailModal, setShowEmailModal ] = useState(false);
    const [emailList, setEmailList ] = useState([]);
    const [selectedTicketContactStatusId, setSelectedTicketContactStatusId] = useState('');




    // Redirect to login if not authenticated
    useEffect(() => {
        if (!authState) {
            navigate('/login');
        }
    }, [authState, navigate]);

    useEffect(() => {
        if (currentYear && schoolYearListParent.length) {
            setSelectedSchoolYear(typeof currentYear === "object" && currentYear !== null && "id" in currentYear ? currentYear.id : currentYear);
            setSchoolYearList(schoolYearListParent);
        }
    }, [currentYear, schoolYearListParent]);

    useEffect(() => {
        if (selectedSchoolYear) {
            setCurrentPage(1);
            fetchEventPrograms();
            fetchEventDates();
            fetchTickets();
            fetchFormSubmissions();
        }
    }, [selectedSchoolYear]);

    useEffect(() => {
        fetchUSAStates();
        fetchRecordStatuses();
        fetchTicketStatus();
        fetchGrades();
        fetchSchools();
        fetchDistricts();
        fetchUserNames();
    }, []);

    useEffect(() => {
        updateDisplayedFormSubmissions(currentPage, filteredSubmissions);
        const emailList = [...new Set(filteredSubmissions.map(submission => submission.email))];
        setEmailList(emailList);
    }, [currentPage, filteredSubmissions]);

    useEffect(() => {
        filterAndPaginate(allFormSubmissions, searchQuery, 1, selectedSearchTerm, startDate, endDate);
    }, [searchQuery, selectedSearchTerm, selectedTicketContactStatusId, allFormSubmissions, tickets, schools, recordStatuses, eventDates, startDate, endDate]);

    const fetchGrades = async () => {
        const url = `${backendURL}/api/grades`
        const response = await fetch(url);
        if (response.ok) {
          const data = await response.json();

          if (Array.isArray(data)) {
            setGrades(data);
        } else {
            console.error('Fetched grades data is not an array:', data);
        }}
      };
      const fetchTicketStatus = async () => {
        const url = `${backendURL}/api/ticket-statuses`
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include'
      })
        if (response.ok) {
          const data = await response.json();
          // console.log("Ticket data was fetched: ", data)

          if (Array.isArray(data)) {
            setTicketStatus(data);
        } else {
            console.error('Fetched ticket statuses data is not an array:', data);
        }}
      };

      const fetchDistricts = async () => {
        const url = `${backendURL}/api/districts`;
        const response = await fetch(url);
        if (response.ok) {
          const data = await response.json();
          setDistricts(data);
        }
      }

      const fetchSchools = async () => {
        setLoading(prev => ({ ...prev, schools: true }));
        const response = await fetch(`${backendURL}/api/schools`);
        
        if (!response.ok) throw new Error('Failed to fetch schools.');
        const data = await response.json();
        
        if (Array.isArray(data)) {
          setSchools(data);
      } else {
          console.error('Fetched Schools data is not an array:', data);

      }}

      const fetchEventPrograms = async () => {
          try {
              setLoading(prev => ({ ...prev, eventPrograms: true }));
              const response = await fetch(`${backendURL}/api/events-programs/year/${selectedSchoolYear}`);
              if (!response.ok) throw new Error('Failed to fetch event programs.');
              let data = await response.json();

              // Filtering the data for event_type_id of 4
              data = data.filter(eventProgram => eventProgram.event_type_id === 4);
              setEventPrograms(data);
          } catch (err) {
              setError(prev => ({ ...prev, eventPrograms: err.message }));
          } finally {
              setLoading(prev => ({ ...prev, eventPrograms: false }));
          }
      };

      const fetchEventDates = async () => {
        try {
            const response = await fetch(`${backendURL}/api/event-dates/year/${selectedSchoolYear}`);
            if (!response.ok) throw new Error('Failed to fetch event dates.');
            const data = await response.json();
            setEventDates(data);

        } catch (err) {
            console.error(err.message);
        }
      };
      const fetchRecordStatuses = async () => {
          try {
              const response = await fetch (`${backendURL}/api/record-status/`, {
                  method: "GET",
                  credentials: "include"
              });
              if (!response.ok) throw new Error ('Failed to fetch record statuses');
              const data = await response.json();
              // console.log("record data: ", data);
              setRecordStatuses(data);
          } catch (error) {
              console.error(error.message);
          }
      }
      const fetchUserNames = async () => {
          try {
              const response = await fetch (`${backendURL}/api/app-users`,{
                  method: 'GET',
                  credentials: 'include'
                });
              const data = await response.json();
              if(!response.ok) throw new Error ('Failed to fetch user data')
              // console.log("Users Data: ",data)
              setUsersNames(data);
          } catch (err) {
              console.error(err.message);
          }
      }
      const fetchUSAStates = async () => {
          try {
              const response = await fetch(`${backendURL}/api/states`, {
                  method: 'GET'
              })
              if (!response.ok) {
                  setErrorMessage('Unable to retrieve list of USA states.')
              }
              const data = await response.json();
              setUSAstates(data);
          } catch{
              setErrorMessage('Failed to retrieve list of USA states.')
          }
        };

        const fetchFormSubmissions = async () => {
            try {
                const response = await fetch(`${backendURL}/api/form-submissions/year/${selectedSchoolYear}`,
                     { method: 'GET', credentials: 'include' });
                const data = response.ok ? await response.json() : [];
                setAllFormSubmissions(data);
                filterAndPaginate(data, searchQuery, currentPage, selectedSearchTerm, startDate, endDate);
            } catch {
                console.error('Error fetching form submissions');
            }
        };
        
        
    
        const fetchTickets = async () => {
            try {
                // if(!selectedSchoolYear === undefined){
                const response = await fetch (`${backendURL}/api/tickets/year/${selectedSchoolYear}`,{
                    method: 'GET',
                    credentials: 'include',
                });
                const data = await response.json();
                if(!response.ok) throw new Error ('Failed to fetch ticket data');
                setTickets(data);
            // }
            } catch (error){
                console.error(error.message);
            }
        }

        const updateDisplayedFormSubmissions = (page, submissions) => {
            const startIndex = (page - 1) * recordsPerPage;
            const endIndex = startIndex + recordsPerPage;
            setDisplayedFormSubmissions(submissions.slice(startIndex, endIndex));
        };

    useEffect(() => {
        if (scrollableTableRef.current && currentScrollPosition !== undefined) {
            scrollableTableRef.current.scrollTop = currentScrollPosition;
        }
    }, [allFormSubmissions, tickets]);

    useWebSocketRoom({
        roomName: buildStaffTicketingRoom(selectedSchoolYear),
        enabled: Boolean(selectedSchoolYear),
        onMessage: (message) => {
            switch (message.entity) {
                case 'form_submission':
                    fetchFormSubmissions();
                    fetchEventDates();
                    break;
                case 'ticket':
                    fetchTickets();
                    break;
                case 'event_date':
                    fetchEventDates();
                    break;
                case 'events_program':
                    fetchEventPrograms();
                    fetchEventDates();
                    break;
                default:
                    break;
            }
        },
    });

    useEffect(() => {
        // console.log("selected event and is editing")
        if (selectedEventProgram && isEditing) {
            // Find the event date from the formData and set it
            const eventDate = eventDates.find(date => date.event_dates_id === formData.event_date_id);

            if (eventDate) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    event_date_id: eventDate.event_dates_id
                }));
            }
        }
    }, [selectedEventProgram, eventDates, formData.event_date_id, isEditing]);
    
    
    const ticketsById = useMemo(() => new Map(tickets.map((ticket) => [ticket.ticket_id, ticket])), [tickets]);
    const schoolsById = useMemo(() => new Map(schools.map((school) => [school.school_id, school])), [schools]);
    const districtsById = useMemo(() => new Map(districts.map((district) => [district.district_id, district])), [districts]);
    const recordStatusById = useMemo(() => new Map(recordStatuses.map((status) => [status.status_id, status])), [recordStatuses]);
    const ticketStatusById = useMemo(() => new Map(ticketStatus.map((status) => [status.ticket_status_id, status])), [ticketStatus]);
    const usersById = useMemo(() => new Map(usersNames.map((user) => [user.user_id, user])), [usersNames]);
    const statesById = useMemo(() => new Map(USAstates.map((state) => [state.state_id, state])), [USAstates]);
    const gradesById = useMemo(() => new Map(grades.map((grade) => [grade.grade_id, grade])), [grades]);
    const eventProgramsById = useMemo(() => new Map(eventPrograms.map((event) => [event.event_id, event])), [eventPrograms]);
    const eventDatesById = useMemo(() => new Map(eventDates.map((eventDate) => [eventDate.event_dates_id, eventDate])), [eventDates]);

    const schoolOptions = useMemo(() => schools.map((school) => {
        const district = districtsById.get(school.district_id);
        const districtName = district ? district.name : 'Unknown District';
        return {
            label: `${school.name} (${districtName})`,
            value: school.school_id
        };
    }), [schools, districtsById]);

    const relevantEventDates = useMemo(() => {
        if (!selectedEventProgram) return [];
  
        return eventDates
          .filter(event_date_id => event_date_id.event_id === Number(selectedEventProgram.value))
          .map(event_date_id => {
              // Parse the start_time and create a Date object. Assuming start_time is in 'HH:mm:ss' format
              const formattedTime = formatTime12Hour(event_date_id.start_time);
                      
              return {
                label: `${event_date_id.date} ${formattedTime}`,
                value: event_date_id.event_dates_id
              };
            });
            
      }, [eventDates, selectedEventProgram]);
    // console.log("relevantEventDates list: ", relevantEventDates)

    const handleEventProgramChange = selectedOption => {
        setSelectedEventProgram(selectedOption);
        setFormData(prevFormData => ({
          ...prevFormData,
          event_program_id: selectedOption ? parseInt(selectedOption.value, 10) : null,
          event_date_id: isEditing ? parseInt(prevFormData.event_date_id, 10) : null // Reset only if not editing
        }));
    };

    const handleShow = () => setShowEmailModal(true);
    const handleClose = () => {
        setShowEmailModal(false)
        setErrorMessage('');
    };

    const handleEventDateChange = (selectedOption) => {
        setFormData({
            ...formData,
            event_date_id: selectedOption ? selectedOption.value : null
        });
    };

    const handleSchoolChange = selectedOption => {
        setSelectedSchool(selectedOption);
        let schoolId = null;
        if (selectedOption) {
            schoolId = parseInt(selectedOption.value, 10);
            if (isNaN(schoolId)) {
                console.warn(`Warning: could not parse school_id value "${selectedOption.value}" as an integer`);
                schoolId = null;
                };
            };
        
        setFormData({
            ...formData,
            school_id: schoolId
            });

        const selectedSchoolObj = schools.find(school_id => school_id.school_id === schoolId);

        if (selectedOption && selectedOption.label.includes("(Private)")) {
            setPrivateSchoolModal(true);
            setDisableSubmit(true);
            // Optionally, you may clear the form and selections here
            setFormData({
                first_name: '',
                last_name: '',
                email: '',
                phone_number: '',
                teacher_status: false,
                cactus_number: '',
                school_id: '',
                district: '',
                event_program_id: '',
                event_date_id: '',
                grade_id: '',
                additional_contact: false,
                street: '',
                city: '',
                state: '',
                zip: '',
                names_to_sit_by: '',
                cactus_number_verified: null
            });
            setSelectedSchool(null);
            setSelectedEventProgram(null);}

        else if (selectedSchoolObj && selectedSchoolObj.name === "Home-School") {
            setHomeSchoolModal(true);
            setDisableSubmit(true);
            setFormData({
                first_name: '',
                last_name: '',
                email: '',
                phone_number: '',
                teacher_status: false,
                cactus_number: '',
                school_id: '',
                district: '',
                event_program_id: '',
                event_date_id: '',
                grade_id: '',
                additional_contact: false,
                street: '',
                city: '',
                state: '',
                zip: '',
                names_to_sit_by: '',
                cactus_number_verified: null
            });
            setSelectedSchool(null);
            setSelectedEventProgram(null);
        } else {
            setDisableSubmit(false);
        }
    
        if (selectedSchoolObj)  {
            // Find the corresponding district object
            const correspondingDistrict = districts.find(district => district.district_id === selectedSchoolObj.district_id);
        
        if (correspondingDistrict) {
            // Update the district in the state
            setSelectedDistrict(correspondingDistrict);

            // Update the district in the formData
            setFormData(prevFormData => ({
                ...prevFormData,
                district: correspondingDistrict.district_id
            }));
        }
      }
    };

    const handleGradeChange = (e) => {
        const gradeValueStr = e.target.value;
        let gradeValue = parseInt(gradeValueStr, 10);
        
        // Check if the parsed value is NaN and handle accordingly
        if (isNaN(gradeValue)) {
            console.warn(`Warning: could not parse grade value "${gradeValueStr}" as an integer`);
            gradeValue = null; // or handle differently based on your use-case
        }
        setFormData({
            ...formData,
            grade_id: gradeValue
        });
    };

    const handleFormChange = (e) => {
        setFormData({
             ...formData, [e.target.name]: e.target.value,
            school_year_id: selectedSchoolYear, });
    };
    const handleTicketFormChange = (e) => {
        setTicketForm({ ...ticketForm, [e.target.name]: e.target.value });
    };

    const handleTicketUpdate = async (e) => {
        e.preventDefault();
        if (ticketForm.ticket_id) {
           await updateTicketForm(ticketForm.ticket_id, ticketForm, submissionLastModified);
        } else {
            console.error("Failed to update ticket data.");
        }

        setTicketForm(INITIAL_TICKET_FORM);
        setShowTicketInfoMod(false);
        setShowTicketNotesMod(false);
        setShowTicketEmailMod(false);
        setTicketToEdit(null);
        setLastModifiedBy(userData.user_id)
        fetchTickets();
        fetchFormSubmissions();
    };

    const updateTicketForm = async (ticketId, ticketForm, submission) => {
        await fetch (`${backendURL}/api/tickets/${ticketId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json'},
            body: JSON.stringify(ticketForm),
            credentials: 'include'
        })
        const updatedSubmission = { 
            ...submission,
            last_modified_by: userData.user_id
         };
        try {
            const res = await fetch(`${backendURL}/api/form-submissions/${submission.submission_id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updatedSubmission),
                credentials: 'include'
            });
            if (!res.ok) {
                throw new Error('Failed to update last modified by');
            }
        } catch(error) {
            console.error("Error updating last modified by on submission")
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.submission_id) {
            const updatedSubmission = { 
                ...formData,
                last_modified_by: userData.user_id
             };
            await updateFormSubmission(formData.submission_id, updatedSubmission);
        } else {
            await createFormSubmission(formData);
        }
        setFormData(INITIAL_FORM_DATA);
        // console.log("form data cleared")
        setShowForm(false);
        setSelectedSchool(null);
        setIsEditing(false);
        fetchFormSubmissions();
        fetchTickets();
    };

    const filterEventDates = (eventDates, startDate, endDate, startTime, endTime) => {
        return eventDates.filter(eventDate => {
            const eventDateTime = new Date(eventDate.date);
            const isWithinDateRange = (!startDate || eventDateTime >= new Date(startDate)) && (!endDate || eventDateTime <= new Date(endDate));
            const isWithinTimeRange = (!startTime || eventDate.start_time >= startTime) && (!endTime || eventDate.end_time <= endTime);
            return isWithinDateRange && isWithinTimeRange;
        });
    };

    const matchesSearch = (submission, searchQueryLowercase, selectedTerm) => {
        const ticket = ticketsById.get(submission.ticket_id);
        const school = schoolsById.get(submission.school_id);
        const recordStatus = recordStatusById.get(submission.record_status_id);

        switch (selectedTerm) {
            case "Name":
                return (submission.first_name?.toLowerCase().includes(searchQueryLowercase) ?? false)
                    || (submission.last_name?.toLowerCase().includes(searchQueryLowercase) ?? false);
            case "Ticket Info":
                if (!ticket) return false;
                return (ticket.seat_number?.toLowerCase().includes(searchQueryLowercase) ?? false)
                    || (ticket.order_number?.toLowerCase().includes(searchQueryLowercase) ?? false);
            case "School (District) Info":
                return school?.name?.toLowerCase().includes(searchQueryLowercase) ?? false;
            case "Contact Info":
                return (submission.email?.toLowerCase().includes(searchQueryLowercase) ?? false)
                    || (submission.phone_number?.toLowerCase().includes(searchQueryLowercase) ?? false);
            case "Record Status":
                return recordStatus?.status?.toLowerCase().includes(searchQueryLowercase) ?? false;
            case "Submitted Date":
                return submission.submitted_date?.toLowerCase().includes(searchQueryLowercase) ?? false;
            case "Ticket Status":
                if (!ticket) return false;
                return String(ticket.ticket_pulled).toLowerCase().includes(searchQueryLowercase)
                    || String(ticket.ticket_mailed).toLowerCase().includes(searchQueryLowercase);
            case "Teachers":
                return submission.teacher_status === true && (
                    (submission.first_name?.toLowerCase().includes(searchQueryLowercase) ?? false)
                    || (submission.last_name?.toLowerCase().includes(searchQueryLowercase) ?? false)
                );
            case "Cactus Unverified":
                return submission.cactus_number_verified == null
                    && submission.teacher_status === true
                    && (
                        (submission.first_name?.toLowerCase().includes(searchQueryLowercase) ?? false)
                        || (submission.last_name?.toLowerCase().includes(searchQueryLowercase) ?? false)
                    );
            default:
                return true;
        }
    };
            
    const filterAndPaginate = (allSubmissions, searchQuery, page, selectedSearchTerm, startDate, endDate) => {
        const searchQueryLowercase = searchQuery.toLowerCase();
        const filteredEventDates = filterEventDates(eventDates, startDate, endDate, startTime, endTime);
        const filteredEventDateIds = new Set(filteredEventDates.map((eventDate) => eventDate.event_dates_id));

        const filteredSubmissions = allSubmissions.filter(submission => {
            const isEventDateMatched = filteredEventDateIds.has(submission.event_date_id);
            const ticketObj = ticketsById.get(submission.ticket_id);
            const matchesTicketContactStatusFilter = selectedTicketContactStatusId
                ? ticketObj?.status_type === Number(selectedTicketContactStatusId)
                : true;
            const matchesSearchTerm =
                searchQueryLowercase
                    ? matchesSearch(submission, searchQueryLowercase, selectedSearchTerm)
                    : true;

            return matchesSearchTerm && matchesTicketContactStatusFilter && isEventDateMatched;

        }).sort((a, b) => a.record_status_id !== 5 && b.record_status_id === 5 ? -1 : b.submission_id - a.submission_id);
        setFilteredSubmissions(filteredSubmissions);
        updateDisplayedFormSubmissions(page, filteredSubmissions);
        setTotalPages(Math.ceil(filteredSubmissions.length / recordsPerPage));
    };
        
    
    

        const createFormSubmission = async (formData) => {
            await fetch(`${backendURL}/api/form-submissions`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
                credentials: 'include'
            });
        };

    const updateFormSubmission = async (submissionId, formData) => {

        await fetch(`${backendURL}/api/form-submissions/${submissionId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
            credentials: 'include'
        });
    };

    const deleteEventTemplate = async () => {
        if (submissionToDelete) {
            try {
                const response = await fetch(`${backendURL}/api/form-submissions/${submissionToDelete}`, {
                    method: 'DELETE',
                    credentials: 'include'
                });
                if (!response.ok){
                    // console.log("insufficient credentials")
                    setShowInsufficientPrivileges(true);
                }
                
            }
            catch{
                console.error("Deleting the form submission failed.")
            }
            
            setSubmissionToDelete(null);
            setShowModal(false);
            fetchFormSubmissions();
            fetchTickets();
        }
    };
    
    const editSubmission = (submission) => {
        setIsEditing(true);
        setFormData(submission);

        //finds the proper event program object from the select list in the form and then sets it if it is true. 
        const programObject = eventPrograms.find(program => program.event_id === submission.event_program_id);
        if (programObject) {
        setSelectedEventProgram({ value: programObject.event_id, label: programObject.name });
        }
    
        const schoolObject = schoolOptions.find(school => school.value === submission.school_id);
        setSelectedSchool(schoolObject);

        setShowForm(true);
    }; 

    const editTicketOrder = (ticket, submission) => {
        setShowTicketInfoMod(true);
        setSubmissionLastModified(submission);
        setTicketToEdit(ticket);
        setTicketForm(ticket);
    } 

    const editTicketNotes = (ticket, submission) => {
        setShowTicketNotesMod(true);
        setSubmissionLastModified(submission);
        setTicketToEdit(ticket);
        setTicketForm(ticket);
    } 

    const editTicketEmailInfo = (ticket, submission) => {
        setShowTicketEmailMod(true);
        setSubmissionLastModified(submission);
        setTicketToEdit(ticket);
        setTicketForm(ticket);
    }

    const handleCancel = () => {
        setIsEditing(false);
        setFormData({
            first_name: '',
            last_name: '',
            email: '',
            phone_number: '',
            teacher_status: false,
            cactus_number: '',
            school_id: '',
            district: '',
            event_program_id: '',
            event_date_id: '',
            grade_id: '',
            additional_contact: false,
            street: '',
            city: '',
            state: '',
            zip: '',
            names_to_sit_by: '',
            cactus_number_verified: null
        });
        setSelectedSchool(null);
        setShowForm(false);
    };

    const handleEdit = async (submissionId, field, value, submission) => {
        // Update the submission object with the new field value
        const updatedSubmission = { 
            ...submission, 
            [field]: value,
            last_modified_by: userData.user_id
         };
        //  console.log("Submission ID: ", submissionId, "Field: ", field, "Value: ", value, "Submission: ", submission)
    
        try {
            const response = await fetch(`${backendURL}/api/form-submissions/${submissionId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updatedSubmission),
                credentials: 'include'
            });
            
            if (!response.ok) {
                throw new Error('Failed to update submission');
            }
    
            // Handle the response, maybe refetch data or show success message
        } catch (error) {
            console.error('Error updating submission: ', error);
            // Handle error, show error message
        }
        // fetchFormSubmissions();
    };

    const handleTicketStatusEdit = async (ticketStatusId, ticket, submission) => {
        const updatedTicket = {
            ...ticket,
            status_type: parseInt(ticketStatusId, 10) // Convert ticketStatusId to an integer
        };
        const updatedSubmission = { 
            ...submission,
            last_modified_by: userData.user_id
         };
        try {
            const res = await fetch(`${backendURL}/api/form-submissions/${submission.submission_id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(updatedSubmission),
                credentials: 'include'
            });
            if (!res.ok) {
                throw new Error('Failed to update last modified by');
            }
        } catch(error) {
            console.error("Error updating last modified by on submission")
        }
        try {
            const response = await fetch(`${backendURL}/api/tickets/${ticket.ticket_id}`, { // Make sure to use ticket.ticket_id instead of ticket
                method: 'PUT',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(updatedTicket),
                credentials: 'include'
            });
            if (!response.ok) throw new Error('Failed to update ticket status');
        } catch (error) {
            console.error('Error updating the ticket status: ', error);
        }
        // fetchFormSubmissions();
        // fetchTickets();
    };

    const HandleUpdateCactusVerification = async (submission, submissionId) => {
        let newCactusNumberVerified;
        
        if (submission.cactus_number_verified === null) {
            newCactusNumberVerified = true;
        } else if (submission.cactus_number_verified === true) {
            newCactusNumberVerified = false;
        } else if (submission.cactus_number_verified === false) {
            newCactusNumberVerified = null;
        }
        
        const updatedSubmission = {
            ...submission,
            cactus_number_verified: newCactusNumberVerified
        };
        
        try {
            const response = await fetch(`${backendURL}/api/form-submissions/${submissionId}`, {
                method: "PUT",
                headers: { 'Content-Type' : 'application/json' },
                body: JSON.stringify(updatedSubmission),
                credentials: "include"
            });
            const data = await response.json();
        } catch {
            console.log("something broke...");
        }
        fetchFormSubmissions();
    };
    
    
    const getLastModifiedName = (userId) => {
        const nameObject = usersById.get(userId);
        return nameObject ? (`${nameObject.first_name} ${nameObject.last_name}`) : 'Unclaimed';
    }

    const getSchoolName = (schoolId) => {
        const schoolObject = schoolOptions.find(school => school.value === schoolId);
        return schoolObject ? schoolObject.label : 'Unknown';
    }

    const getRecordStatusColor = (recordId) => {
        const recordObject = recordStatusById.get(recordId);
        // Log the color if the recordObject is found
        if (recordObject) {
            return recordObject.color; // Return only the color value
        }
        return 6; // Return a default color if not found
    };
    
    const getTicketStatusColor = (ticketId) => {
        try {const ticketObj = getTicketObj(ticketId);
        const ticketStatObj = ticketStatusById.get(ticketObj.status_type);
        // Log the color if the ticketStatus is found
        if (ticketStatObj) {
            return ticketStatObj.color; // Return only the color value
        }}
        catch{
        return 'White';}
    };

    const getSubmissionRecordStatus = (submissionObj) => {
        if (submissionObj.record_status_id) {
            return submissionObj.record_status_id;
        }
        return 6;
    }

    const getGradeType = (gradeId) => {
        const grade = gradesById.get(gradeId);
        if (grade) {
          return grade.grade
        }
        return "Unknown Grade";
      }
    const getEventName = (eventID) => {
        const event = eventProgramsById.get(eventID);
        if (event) {
          return event.name
        }
        return "Unknown Program";
    }
    const getEventDate = (eventDateId) => {
        const event = eventDatesById.get(eventDateId);
        
        if (event) {
            // Assuming event.start_time is in 'HH:MM:SS' format
            const formattedTime = formatTime12Hour(event.start_time);
    
            return `${event.date} at ${formattedTime}`;
        }
    
        return "Unknown Event Date";
    };
    const getTicketInfo = (ticketId, submission) => {
        const ticketObj = ticketsById.get(ticketId);
        return ticketObj ? (
            <div className="ticket-info-container">
                <Button onClick={() => editTicketOrder(getTicketObj(ticketId), submission)} className="edit-ticket-button">
                    <i className="bi bi-pencil-square"></i>
                </Button>
                <span>
                    Seat: {ticketObj.seat_number}
                    <br />
                    Order: {ticketObj.order_number}
                </span>
            </div>
        ) : 'Ticket Not Assigned';
    }
    const getTicketNotes = (ticketId, submission) => {
        const ticketObj = ticketsById.get(ticketId);
        return ticketObj ? (
            <div className="ticket-notes-container">
                <Button onClick={() => editTicketNotes(getTicketObj(ticketId), submission)} className="ticket-notes-button">
                    Notes
                </Button>
                <span>
                    {ticketObj.notes}
                </span>
            </div>
        ) : 'Ticket Not Assigned';
    }
    const getTicketEmailInfo = (ticketId, submission) => {
        const ticketObj = ticketsById.get(ticketId);
        return ticketObj ? (
            <div className="ticket-info-container">
                <Button onClick={() => editTicketEmailInfo(getTicketObj(ticketId), submission)} className="edit-ticket-button">
                <i className="bi bi-pencil-square"></i>
                </Button>
                <span>
                    Reminder Email: 
                        <i 
                            className={`bi ${ticketObj.ticket_mailed ? 'bi-check-circle-fill icon-true' : 'bi-x-circle-fill icon-false'}`}
                        ></i>
                    <br />
                    Ticket Picked up: 
                        <i 
                            className={`bi ${ticketObj.ticket_pulled ? 'bi-check-circle-fill icon-true' : 'bi-x-circle-fill icon-false'}`}
                        ></i>
                </span>

            </div>
        ) : 'Ticket Not Assigned';
    }


    const getTicketObj = (ticketId) => {
        try{{const ticketObj = ticketsById.get(ticketId);
        if(ticketObj)
            {return ticketObj;}
        else {
            return null;
        }}}
        catch{
            setErrorMessage('no ticket')
            return null;
        }
    }
    const getTicketStatus = (ticketId) => {
        const ticketObj = ticketsById.get(ticketId);
        return ticketObj ? (ticketObj.status_type) : 8;
    }    

    const getStateObj = (stateId) => {
        const id = Number(stateId);
        const stateObj = statesById.get(id);
        return stateObj ? (stateObj.state_name) : <span style={{color: 'red'}}>failed to load</span>;
    }

    const resetFormAndState = () => {
        setFormData(INITIAL_FORM_DATA);
        setIsEditing(false);
        setSelectedSchool(null);
        // Reset any other state as necessary
    };

    const toggleFormView = () => {
        setShowForm(!showForm);
        if (showForm) {
            // If we are hiding the form, reset the state
            resetFormAndState();
        }
        // Optionally, handle else case if you need to do anything specific when showing the form
    };

    const TableRowComponent = React.memo(({
        submission,
        getEventName,
        getEventDate,
        getSchoolName,
        getGradeType,
        getTicketStatusColor,
        getTicketStatus,
        handleTicketStatusEdit,
        getTicketObj,
        getTicketNotes,
        getRecordStatusColor,
        getStateObj,
        getSubmissionRecordStatus,
        handleEdit,
        getLastModifiedName,
        getTicketEmailInfo,
        editSubmission,
        setSubmissionToDelete,
        setShowModal,
        ticketStatus
      }) => {
        const ticketObj = getTicketObj(submission.ticket_id);
        const address = submission.street
            ? `${submission.street}, ${submission.city}, ${getStateObj(submission.state, submission)}, ${submission.zip}`
            : null;
        // Keep real per-status colors, but let the 'White' default fall through to
        // the themed table cell so the column adapts to dark mode.
        const rawWorkflowColor = getTicketStatusColor(submission.ticket_id);
        const hasWorkflowColor = rawWorkflowColor && rawWorkflowColor.toLowerCase() !== 'white';
        const workflowBgColor = hasWorkflowColor ? rawWorkflowColor : undefined;
        const workflowTextColor = hasWorkflowColor ? getContrastTextColor(rawWorkflowColor) : undefined;

        return (
          <tr key={submission.submission_id}>
            <td className="ticket-cell-requester">
                <div className="ticket-row-title">{submission.first_name} {submission.last_name}</div>
                <div className="ticket-row-meta">{submission.submitted_date}</div>
                <div className="d-flex flex-wrap gap-2 mt-2">
                    <Badge bg={submission.additional_contact ? "success" : "secondary"}>
                        Extra Tickets: {submission.additional_contact ? "Yes" : "No"}
                    </Badge>
                    <Badge bg={submission.teacher_status ? "primary" : "light"} text={submission.teacher_status ? undefined : "dark"}>
                        Teacher: {submission.teacher_status ? "Yes" : "No"}
                    </Badge>
                </div>
                {submission.teacher_status && (
                    <div className="mt-2 small">
                        <div><strong>Cactus #:</strong> {submission.cactus_number || "N/A"}</div>
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary mt-1"
                            onClick={() => HandleUpdateCactusVerification(submission, submission.submission_id)}
                        >
                            Cactus Verified:{" "}
                            {submission.cactus_number_verified === null ? "Unknown" : submission.cactus_number_verified ? "Yes" : "No"}
                        </button>
                    </div>
                )}
            </td>

            <td className="ticket-cell-event">
                <div className="ticket-row-label">Event</div>
                <div>{getEventName(submission.event_program_id)}</div>
                <div className="ticket-row-meta">{getEventDate(submission.event_date_id)}</div>
                <div className="mt-2">
                    <div>{getTicketInfo(submission.ticket_id, submission)}</div>
                    <div className="mt-1">{getTicketNotes(submission.ticket_id, submission)}</div>
                </div>
            </td>

            <td className="ticket-cell-school-contact">
                <div><strong>School:</strong> {getSchoolName(submission.school_id)}</div>
                <div><strong>Grade:</strong> {getGradeType(submission.grade_id)}</div>
                <div className="mt-2"><strong>Email:</strong> {submission.email || "N/A"}</div>
                <div><strong>Phone:</strong> {submission.phone_number || "N/A"}</div>
                <div className="mt-2"><strong>Address:</strong> {address || <span className="text-danger">Not provided</span>}</div>
                <div><strong>Sit By:</strong> {submission.names_to_sit_by || "N/A"}</div>
            </td>

            <td className='ticket-cell-workflow' style={{ backgroundColor: workflowBgColor, color: workflowTextColor }}>
                <div className="ticket-row-label" style={{ color: workflowTextColor }}>Ticket Contact Status</div>
                <Form.Control
                as='select'
                value={getTicketStatus(submission.ticket_id)}
                name='ticket_id'
                className="workflow-select"
                style={{ color: 'var(--bs-body-color)' }}
                onChange={(e) => handleTicketStatusEdit(
                    e.target.value,
                    getTicketObj(submission.ticket_id),
                    submission
                )}>
                    {ticketStatus.map(tStatus => (
                        <option key={tStatus.ticket_status_id} value={tStatus.ticket_status_id}>{tStatus.name}</option>
                    ))}

                </Form.Control>
                <div className="mt-2">{getTicketEmailInfo(submission.ticket_id, submission)}</div>
                <div className="ticket-row-label mt-2" style={{ color: workflowTextColor }}>Record Status</div>
                <Form.Control
                    as="select"
                    value={getSubmissionRecordStatus(submission)}
                    name="record_status_id"
                    id={submission.submission_id}
                    className="workflow-select"
                    style={{ color: 'var(--bs-body-color)' }}
                    onChange={(e) => handleEdit(
                        submission.submission_id,
                            "record_status_id",
                            e.target.value,
                            submission)
                            }>
                    {recordStatuses.map(record => (
                        <option key={record.status_id} value={record.status_id}>{record.status}</option>
                    ))}
                </Form.Control>
                <div className="ticket-row-meta mt-1" style={{ color: workflowTextColor }}>Last modified: {getLastModifiedName(submission.last_modified_by)}</div>
            </td>

            <td className="ticket-cell-actions">
                <div className="d-flex flex-column gap-2">
                    <Button onClick={() => editSubmission(submission)} size="sm">
                        <i className="bi bi-pencil-square"></i> Edit Submission
                    </Button>
                    <Button variant="danger" size="sm" onClick={() => {
                    setSubmissionToDelete(submission.submission_id);
                    setShowModal(true);
                    }}>
                        <i className="bi bi-trash3"></i> Delete
                    </Button>
                    <Button
                        variant="outline-secondary"
                        size="sm"
                        onClick={() => editTicketOrder(ticketObj, submission)}
                        disabled={!ticketObj || typeof ticketObj !== "object"}
                    >
                        <i className="bi bi-ticket-perforated"></i> Edit Ticket
                    </Button>
                </div>
            </td>                        
          </tr>
        );
      });
    
    const handleSearchTermChange = (value) => {
        setSelectedSearchTerm(value);
        setCurrentPage(1);
        setSearchQuery('');
    };

    const DropDownFilterSelection = ({options}) => (
        <div className='search-section-ticket-office'>
            <span className='search-title-ticket-office'>Select Your Search Term</span>
            <Form.Control
            as='select'
            value={selectedSearchTerm}
            name='searchQueryValue'
            onChange = {(e) => handleSearchTermChange(e.target.value)}
            className='search-selection-ticket-office'
            >
            {options.map((head, index) => (
                <option key={index} value={head}>{head}</option>
            ))}
            </Form.Control>
        </div>
    );

    const clearAllFilters = () => {
        setSearchQuery('');
        setSelectedSearchTerm('Name');
        setSelectedTicketContactStatusId('');
        setStartDate(null);
        setEndDate(null);
        setCurrentPage(1);
    };
    
    const handleYearChange = (event) => {
        setSelectedSchoolYear(event.target.value);
    };

  const getPaginationItems = () => {
    const items = [];
    const MAX_PAGES_DISPLAYED = 5;
    let startPage = Math.max(currentPage - Math.floor(MAX_PAGES_DISPLAYED / 2), 1);
    let endPage = Math.min(startPage + MAX_PAGES_DISPLAYED - 1, totalPages);

    if (endPage - startPage + 1 < MAX_PAGES_DISPLAYED) {
        startPage = Math.max(endPage - MAX_PAGES_DISPLAYED + 1, 1);
    }

    items.push(
        <Pagination.Prev key="prev" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} />
    );

    for (let number = startPage; number <= endPage; number++) {
        items.push(
            <Pagination.Item key={number} active={number === currentPage} onClick={() => setCurrentPage(number)}>
                {number}
            </Pagination.Item>
        );
    }

    items.push(
        <Pagination.Next key="next" disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} />
    );

    return items;
};
    
    return (
        <div>
            {authState && <NavbarComponent />}
            <Button onClick={toggleFormView} className="m-1">
                {showForm ? 'Show Ticket Submissions List' : 'Add New Ticket Submission'}
            </Button>
            <div>
                <Dropdown>
                <span className='fw-bold'>Select School Year</span>
                <select value={selectedSchoolYear} onChange={handleYearChange}>
                    <option value="" disabled>Select School Year</option>
                    {schoolYearList.map((year) => (
                        <option key={year.id} value={year.id}>
                        {year.school_year}
                        </option>
                    ))}
                    </select>
                </Dropdown>
            </div>
            <p>
                {'Displaying '} {displayedFormSubmissions.length}
                {' of '} {filteredSubmissions.length}
                {' Total Submissions.'} 
            </p>
            {!showForm ? 
            <Card className="mb-3 shadow-sm">
                <Card.Body>
                    <Row className="g-3 align-items-end">
                        <Col xs={12} lg={3}>
                            <DropDownFilterSelection options={SEARCH_TERM_OPTIONS} />
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group controlId="search" className='search-bar-ticket-office'>
                                <Form.Label className="fw-bold">Search</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={searchQuery}
                                    placeholder={`Search by ${selectedSearchTerm.toLowerCase()}...`}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group controlId="ticketContactStatusFilter">
                                <Form.Label className="fw-bold">Ticket Contact Status</Form.Label>
                                <Form.Select
                                    value={selectedTicketContactStatusId}
                                    onChange={(e) => {
                                        setSelectedTicketContactStatusId(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                >
                                    <option value="">All</option>
                                    {ticketStatus.map((status) => (
                                        <option key={status.ticket_status_id} value={status.ticket_status_id}>
                                            {status.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} lg={2}>
                            <Form.Group controlId="startDate">
                                <Form.Label className="fw-bold">Start Date</Form.Label>
                                <DatePicker
                                    selected={startDate}
                                    onChange={date => setStartDate(date)}
                                    dateFormat="yyyy-MM-dd"
                                    className="custom-datepicker"
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} sm={6} lg={2}>
                            <Form.Group controlId="endDate">
                                <Form.Label className="fw-bold">End Date</Form.Label>
                                <DatePicker
                                    selected={endDate}
                                    onChange={date => setEndDate(date)}
                                    dateFormat="yyyy-MM-dd"
                                    className="custom-datepicker"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="d-flex flex-wrap gap-2 mt-3 align-items-center">
                        <Button variant="outline-secondary" onClick={clearAllFilters}>Clear All Filters</Button>
                        <Button variant="primary" onClick={handleShow}>Generate Email List for Current Selection</Button>
                        <Badge bg="secondary">
                            Showing {filteredSubmissions.length} of {allFormSubmissions.length}
                        </Badge>
                    </div>
                </Card.Body>
            </Card>
         : <></>}
            
            {showForm ? (
                <Form onSubmit={handleSubmit}>
                    <Form.Group className='ticket-office-groups' controlId="first_name">
                        <Form.Label className={'ticket-office-form-labels'}>Guardian First Name</Form.Label>
                        <Form.Control 
                            type="text"
                            placeholder="Enter first name"
                            name="first_name"
                            onChange={handleFormChange}
                            value={formData.first_name}
                        />
                    </Form.Group>
                    <Form.Group className='ticket-office-groups' controlId="last_name">
                        <Form.Label className={'ticket-office-form-labels'}>Guardian Last Name</Form.Label>
                        <Form.Control 
                            type="text"
                            placeholder="Enter last name"
                            name="last_name"
                            onChange={handleFormChange}
                            value={formData.last_name}
                        />
                    </Form.Group>
                    <Form.Group className='ticket-office-groups' controlId="email">
                        <Form.Label className={'ticket-office-form-labels'}>Email</Form.Label>
                        <Form.Control 
                            type="text"
                            placeholder="Enter email"
                            name="email"
                            onChange={handleFormChange}
                            value={formData.email}
                        />
                    </Form.Group>
                    <Form.Group className='ticket-office-groups' controlId="phone_number">
                        <Form.Label className={'ticket-office-form-labels'}>Phone Number</Form.Label>
                        <Form.Control 
                            type="text"
                            placeholder="Enter phone_number"
                            name="phone_number"
                            onChange={handleFormChange}
                            value={formData.phone_number}
                        />
                    </Form.Group>
                    <Form.Group className='ticket-office-groups' controlId="street">
                        <Form.Label className={'ticket-office-form-labels'}>Street</Form.Label>
                        <Form.Control
                        type='text'
                        placeholder='Enter Street'
                        name='street'
                        required
                        onChange={handleFormChange}
                        value={formData.street}>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className='ticket-office-groups' controlId='city'>
                        <Form.Label className={'ticket-office-form-labels'}>City</Form.Label>
                        <Form.Control
                        type='text'
                        placeholder='Enter City'
                        name='city'
                        required
                        onChange={handleFormChange}
                        value={formData.city}>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className='ticket-office-groups' controlId='state'>
                        <Form.Label className={'ticket-office-form-labels'}>State</Form.Label>
                        <Form.Control
                        as='select'
                        required
                        name='state'
                        onChange={handleFormChange}
                        value={formData.state}>
                            <option value={''}>Choose State</option>
                            {USAstates.map(state => (
                                <option value={state.state_id} key={state.state_id}>{state.state_name}, {state.abbreviation}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className='ticket-office-groups' controlId='zip'>
                        <Form.Label className={'ticket-office-form-labels'}>Zip</Form.Label>
                        <Form.Control
                        type='text'
                        placeholder='Enter Zip'
                        name='zip'
                        required
                        onChange={handleFormChange}
                        value={formData.zip}>
                        </Form.Control>
                    </Form.Group>
                    {/* <Form.Group className='ticket-office-groups' controlId="student_name">
                        <Form.Label className={'ticket-office-form-labels'}>Student Name</Form.Label>
                        <Form.Control 
                            type="text"
                            placeholder="Enter student name"
                            name="student_name"
                            onChange={handleFormChange}
                            value={formData.student_name}
                        />
                    </Form.Group> */}
                    <Form.Group className='ticket-office-groups' controlId="teacher_status">
                        <Form.Label className={'ticket-office-form-labels'}>Teacher Status</Form.Label>
                        <Form.Check 
                            type="checkbox"
                            label="Is a teacher"
                            name="teacher_status"
                            onChange={e => handleFormChange({target: {name: e.target.name, value: e.target.checked}})}
                            checked={formData.teacher_status}
                        />
                    </Form.Group>
                    <Form.Group className='ticket-office-groups' controlId="cactus_number">
                        <Form.Label className={'ticket-office-form-labels'}>Cactus Number</Form.Label>
                        <Form.Control 
                            type="text"
                            placeholder="Enter cactus number"
                            name="cactus_number"
                            onChange={handleFormChange}
                            value={formData.cactus_number}
                        />
                    </Form.Group>
                    <Form.Group className='ticket-office-groups' controlId="grade_id">
                        <Form.Label className={'ticket-office-form-labels'}>Grade</Form.Label>
                        <Form.Control 
                            as="select"
                            name="grade_id"
                            onChange={handleGradeChange}
                            value={formData.grade_id}
                        ><option value="">Select Grade</option>
                        {Array.isArray(grades) && grades.map(grade => (
                            <option key={grade.grade_id} value={grade.grade_id}>{grade.grade}</option>
                        ))}
                        </Form.Control> 
                    </Form.Group>
                    <Form.Group className='ticket-office-groups' controlId="school_id">
                        <Form.Label className={'ticket-office-form-labels'}>School</Form.Label>
                        <Select 
                            isSearchable={true}
                            options={schoolOptions}
                            value={selectedSchool}
                            onChange={handleSchoolChange}
                            inputId="school_id"
                        />
                    </Form.Group>
                    {/* <Form.Group className='ticket-office-groups' controlId="email">
                        <Form.Label className={'ticket-office-form-labels'}>District</Form.Label>
                        <Form.Control 
                            type="text"
                            placeholder="Enter district"
                            name="district"
                            onChange={handleFormChange}
                            value={formData.district}
                        />
                    </Form.Group> */}
                    <Form.Group className='ticket-office-groups' controlId="event_program_id">
                    <Form.Label className={'ticket-office-form-labels'} >Event Program</Form.Label>
                        <Form.Control 
                        as="select"
                        name="event_program_id"
                        value={formData.event_program_id}
                        onChange={e => handleEventProgramChange({ value: e.target.value, label: e.target.options[e.target.selectedIndex].text })}
                        >
                        <option value="">Select Event Program</option>
                        {eventPrograms.map(program => (
                            <option key={program.event_id} value={program.event_id}>{program.name}</option>
                        ))}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className='ticket-office-groups' controlId="event_date_id">
                        <Form.Label className={'ticket-office-form-labels'} >Event Date</Form.Label>
                        <Select 
                            options={relevantEventDates}
                            onChange={handleEventDateChange}
                            value={relevantEventDates.find(date => date.value === formData.event_date_id) || null}
                            placeholder="Select Event Date"
                            isDisabled={!selectedEventProgram }
                            inputId="event_date_id"
                        />
                    </Form.Group>
                    <Form.Group className='ticket-office-groups' controlId="additional_contact">
                        <Form.Label className={'ticket-office-form-labels'}>Would you like to be contacted for additional tickets?</Form.Label>
                        <Form.Check 
                            type="checkbox"
                            label="Yes"
                            name="additional_contact"
                            onChange={e => handleFormChange({target: {name: e.target.name, value: e.target.checked}})}
                            checked={formData.additional_contact}
                        />
                    </Form.Group>

                    <Button type="submit" className="m-1">{ isEditing ? "Update" : "Submit"}</Button>
                    <Button variant="secondary" onClick={handleCancel} className="ml-2">Cancel</Button>
                </Form>
            ) : (
                <>
                {/* <FixedHeader/> */}
            <div ref={scrollableTableRef} className="scrollable-table">
            <Table striped bordered hover>
                    <thead>
                        <tr className='table-heading'>
                            <th className='name-office-ticket-table'>Requester</th>
                            <th className='ticket-office-ticket-table'>Event & Ticket</th>
                            <th className='school-office-ticket-table'>School & Contact</th>
                            <th className='ticket-status-office-ticket-table'>Workflow</th>
                            <th className='actions-office-ticket-table'>Actions</th>
                        </tr>
                    </thead>
                    <tbody className='text-left main-ticket-office-table'>
                        {displayedFormSubmissions.map((submission) => (
                            <TableRowComponent
                            key={submission.submission_id}
                            submission={submission}
                            getEventName={getEventName}
                            getEventDate={getEventDate}
                            getSchoolName={getSchoolName}
                            getGradeType={getGradeType}
                            getTicketStatusColor={getTicketStatusColor}
                            getTicketStatus={getTicketStatus}
                            handleTicketStatusEdit={handleTicketStatusEdit}
                            getTicketObj={getTicketObj}
                            getStateObj={getStateObj}
                            getTicketNotes={getTicketNotes}
                            getRecordStatusColor={getRecordStatusColor}
                            getSubmissionRecordStatus={getSubmissionRecordStatus}
                            handleEdit={handleEdit}
                            getLastModifiedName={getLastModifiedName}
                            getTicketEmailInfo={getTicketEmailInfo}
                            editSubmission={editSubmission}
                            setSubmissionToDelete={setSubmissionToDelete}
                            setShowModal={setShowModal}
                            ticketStatus={ticketStatus}
                          />
                          ))}
                    </tbody>
            </Table>
        </div>
        {showForm ? "" : (
            <Pagination className="justify-content-center">
        {getPaginationItems()}
      </Pagination> )}
                </>
            )}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this ticket submission?</Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={deleteEventTemplate}>
                        Delete
                    </Button>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showTicketInfoMod} onHide={() => setShowTicketInfoMod(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Ticket Information</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId='order_number'>
                            <Form.Label>Order Number</Form.Label>
                            <Form.Control
                            type='text'
                            name='order_number'
                            value={ticketForm.order_number}
                            onChange={e => handleTicketFormChange({target: {name: e.target.name, value: e.target.value}})}
                            />
                        </Form.Group>
                        <Form.Group controlId='seat_number'>
                            <Form.Label>Seat Number</Form.Label>
                            <Form.Control
                            type='text'
                            name='seat_number'
                            value={ticketForm.seat_number}
                            onChange={e => handleTicketFormChange({target: {name: e.target.name, value: e.target.value}})}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleTicketUpdate}>Update</Button>
                    <Button variant='secondary' onClick={() => {setShowTicketInfoMod(false)}}>Close</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showTicketsNotesMod} onHide={() => setShowTicketNotesMod(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Ticket Notes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId='notes'>
                            <Form.Label>Notes</Form.Label>
                            <Form.Control
                            as='textarea'
                            name='notes'
                            value={ticketForm.notes}
                            rows={15}
                            className='ticket-notes-field-mod'
                            onChange={e => handleTicketFormChange({target: {name: e.target.name, value: e.target.value}})}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleTicketUpdate}>Update</Button>
                    <Button variant='secondary' onClick={() => {setShowTicketNotesMod(false)}}>Close</Button>
                </Modal.Footer>
            </Modal>            
            <Modal show={showTicketEmailMod} onHide={() => setShowTicketEmailMod(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Ticket Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId='ticket_mailed' className="left-aligned-checkbox">
                            {/* <Form.Label>Ticket Mailed</Form.Label> */}
                            <Form.Check
                            label='Ticket Mailed'
                            type='checkbox'
                            name='ticket_mailed'
                            checked={ticketForm.ticket_mailed}
                            className='ticket-email-field-mod'
                            onChange={e => handleTicketFormChange({target: {name: e.target.name, value: e.target.checked}})}
                            />
                        </Form.Group>
                        <Form.Group controlId='ticket_pulled' className="left-aligned-checkbox">
                            {/* <Form.Label>Ticket Pulled</Form.Label> */}
                            <Form.Check
                            label='Ticket Pulled'
                            type='checkbox'
                            name='ticket_pulled'
                            checked={ticketForm.ticket_pulled}
                            className="ticket-email-field-mod"
                            onChange={e => handleTicketFormChange({target: {name: e.target.name, value: e.target.checked}})}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleTicketUpdate}>Update</Button>
                    <Button variant='secondary' onClick={() => {setShowTicketEmailMod(false)}}>Close</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showInsufficientPrivileges} onHide={() => setShowInsufficientPrivileges(false)}>
                <Modal.Header>
                    <Modal.Title>Insufficient Privileges</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Your account doesn't have the right privileges to perform this action.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={() => {setShowInsufficientPrivileges(false)}}>Close</Button>
                </Modal.Footer>
            </Modal>
            <EmailModal show={showEmailModal} handleClose={handleClose} emails={emailList}/>
            <ErrorModalMessage errorMessage={errorMessage} handleClose={handleClose} clearErrorMessage={() => setErrorMessage('')}></ErrorModalMessage>
        </div>
    );
    

};

export default EventTemplateComponent;
